"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "app-container"
  }, [_c("div", {
    staticClass: "filter-container"
  }, [_c("router-link", {
    attrs: {
      to: "/game-levels/add"
    }
  }, [_c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    staticClass: "filter-item",
    attrs: {
      type: "warning",
      icon: "el-icon-plus"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.add")) + " ")])], 1)], 1), _c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.list,
      border: "",
      fit: "",
      "highlight-current-row": ""
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "id",
      label: "ID",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      prop: "name",
      label: "Name"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      prop: "title",
      label: "Title"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "160",
      prop: "tagLine",
      label: "Tag Line"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "200",
      prop: "description",
      label: "Description"
    }
  }), _c("el-table-column", {
    attrs: {
      width: "120",
      label: "Image"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [scope.row.image ? _c("el-image", {
          staticStyle: {
            width: "80px",
            height: "80px"
          },
          attrs: {
            src: `${scope.row.image}-md`,
            "preview-src-list": [scope.row.image + "-og"],
            fit: "fill"
          }
        }) : _vm._e()];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "Colour"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v("Start: " + _vm._s(scope.row.startColour))]), _c("div", [_vm._v("End: " + _vm._s(scope.row.endColour))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "Value"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v("Start: " + _vm._s(scope.row.startValue))]), _c("div", [_vm._v("End: " + _vm._s(scope.row.endValue))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      width: "100",
      label: "Created On"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("div", [_vm._v(_vm._s(_vm._f("moment")(scope.row.createdTimestamp, "DD-MM-YYYY")))])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "Actions",
      width: "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (scope) {
        return [_c("router-link", {
          attrs: {
            to: "/game-levels/edit/" + scope.row.id
          }
        }, [_c("el-button", {
          attrs: {
            type: "primary",
            size: "mini",
            icon: "el-icon-edit"
          }
        })], 1)];
      }
    }])
  })], 1), _c("pagination", {
    attrs: {
      total: _vm.total,
      page: _vm.listQuery.page,
      limit: _vm.listQuery.limit
    },
    on: {
      "update:page": function ($event) {
        return _vm.$set(_vm.listQuery, "page", $event);
      },
      "update:limit": function ($event) {
        return _vm.$set(_vm.listQuery, "limit", $event);
      },
      pagination: _vm.getList
    }
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;